var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountCircleFill = function SvgAccountCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9M7.12 15.074c1.322 1.971 3.305 3.226 5.524 3.226s4.202-1.254 5.522-3.226a8.07 8.07 0 0 0-5.522-2.174 8.07 8.07 0 0 0-5.523 2.174ZM12.5 11.1a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4"
  })));
};
export default SvgAccountCircleFill;